import { TreeNodeType } from "../enum/tree-node-type";


export class NodeTypes {
  public static getNodeType(object: any): TreeNodeType {
    if (object == undefined) {
      return TreeNodeType.Unknown;
    }

    if (TreeNodeType.Source in object) {
      return TreeNodeType.Source;
    }
    if (TreeNodeType.Group in object) {
      return TreeNodeType.Group;
    }
    if (TreeNodeType.Device in object) {
      return TreeNodeType.Device;
    }
    if (TreeNodeType.Telemetry in object) {
      return TreeNodeType.Telemetry;
    }
    if (TreeNodeType.ObjectNode in object) {
      return TreeNodeType.ObjectNode;
    }
    if (TreeNodeType.ArrayNode in object) {
      return TreeNodeType.ArrayNode;
    }
    return TreeNodeType.Unknown;
  } // getNodeType()

} // class NodeTypes

